import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@hobs/components/Dialog';
import { Formik, Form, Field } from 'formik';
import { RaisedButton, GhostButton } from '@hobs/components/Buttons';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';

import './ExerciseSelectionDialog.scss';
import Dropdown from '@hobs/components/Dropdown';

class ExerciseSelectionDialog extends PureComponent {
  validationSchema = Yup.object().shape({
    exerciseId: Yup.string()
      .nullable()
      .required('Please select an exercise')
  });

  constructor(props) {
    super(props);
  }

  onSubmit = (values, actions) => {
    const exercise = this.props.exercises.find(
      x => x.exerciseId === values.exerciseId
    );
    this.props.onSubmit({
      exerciseId: exercise.exerciseId,
      title: exercise.title ? exercise.title : exercise.name
    });
    this.props.onClose();
  };

  render() {
    const { isOpen, onClose, t, exercises } = this.props;

    return (
      <Dialog title={t('Select exercise')} isOpen={isOpen} onClose={onClose}>
        <Formik
          enableReinitialize={true}
          initialValues={{ exerciseId: null }}
          onSubmit={this.onSubmit}
          validationSchema={this.validationSchema}
        >
          {({}) => {
            return (
              <Form className="copy-from-exercise-form">
                <Field name="exerciseId" component={Dropdown}>
                  <option selected hidden disabled value={null}>
                    {t('Select an exercise')}
                  </option>
                  {exercises.map(exercise => {
                    return (
                      <option
                        key={exercise.exerciseId}
                        value={exercise.exerciseId}
                      >
                        {exercise.title ? exercise.title : exercise.name}
                      </option>
                    );
                  })}
                </Field>
                <div className="copy-from-exercise-form--buttons">
                  <RaisedButton type="submit">{t('Copy')}</RaisedButton>
                  <GhostButton onClick={onClose}>{t('Close')}</GhostButton>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    );
  }
}

ExerciseSelectionDialog.propTypes = {
  isOpen: PropTypes.bool,
  t: PropTypes.func,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  exercises: PropTypes.array
};
const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ExerciseSelectionDialog)));
